<template lang="pug">
  #archived-member-challenges
    .level.is-mobile
      .level-left
        .level-item
          WtTitle(card-title) My Archived Challenges
      .level-right
        WtButton(@click.native="open = !open" is-text color="grey") {{ open ? 'Hide' : 'View' }}
    WtEntityTable(
      v-show="open"
      title=""
      has-title-large
      :data="_.get(archivedChallengesObject, 'data', [])"
      :pagination-object="archivedChallengesObject.pagination"
      :fetch-action="fetchAction"
      default-sort-field="name"
      empty-message="No completed challenges."
      :showEmptyMessage="!loading"
    )
      BTableColumn(field="name" label="Challenge Name" v-slot="column")
        BTooltip(
          label="View this challenge"
          position="is-top"
          animated
        )
          WtRouterLink(
            to="Challenge"
            :params="{ challengeId: column.row.id }"
            :text="column.row.name"
            type="table"
          )
      BTableColumn(field="between" label="Type" v-slot="column")
        | {{ challengeType(column.row.between) }}
      BTableColumn(
        field="startDate"
        label="Start Date"
        v-slot="column"
      )
        | {{ date(column.row.startDate, "DATE_FORMAT_SLASH").formatted }}
      BTableColumn(
        field="endDate"
        label="End Date"
        v-slot="column"
      )
        | {{ date(column.row.endDate, "DATE_FORMAT_SLASH").formatted }}
      BTableColumn(
        label="Result"
        field="goalMet"
        v-slot="column"
      )
        span(:class="column.row.goalMet ? 'has-text-success' : ''")
          | {{ column.row.goalMet ? "Goal Met" : "Incomplete" }}
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

export default {
  name: "MemberChallengesArchiveTable",

  components: { WtEntityTable, WtButton, WtRouterLink, WtTitle },

  mixins: [tablePropsMixin, dateUtilityMixin, challengeMixin],

  props: {
    archivedChallengesObject: {
      type: Object,
      required: true
    },

    fetchAction: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="sass" scoped></style>
